export const lanesCameraStatusArr = [
  {label: "Ativa", value: "true"},
  {label: "Inativa", value: "false"},
  {label: "Alerta", value: "alert"},
];

export const lanesTypeArr = [
  {label: "API", value: "API"},
  {label: "Sentry Cloud", value: "Sentry Cloud"},
  {label: "Smartcapture", value: "Smartcapture"},
  {label: "App Captura Móvel", value: "App Captura Móvel"},
  {label: "Móvel", value: "Móvel"},
  {label: "Simulador", value: "Simulador"},
];

export const TypeIntegrationsEnum = {VMS: "VMS"}

export const LaneTypeEnum = {
  API: "API",
  SENTRY_CLOUD: "SENTRY_CLOUD",
  SMARTCAPTURE: "INTERNAL_SMARTCAPTURE",
  MOBILE_APP: "MOBILE_APP",
  MOBILE_CAMERA: "MOBILE_CAMERA",
  SIMULATOR: "SIMULATOR",
}

export const ImageTypeEnum = {
  ALL: "ALL",
  TRAFFIC: "TRAFFIC_OFFENCE",
  DEMAND: "ON_DEMAND",
  NONE: "NONE"
}

export const OcrEnum = {
  DISABLED: "DISABLED",
  SUPPLEMENT: "SUPPLEMENT",
  OVERWRITE: "OVERWRITE"
}

export const laneTypes = [
  {name: '', value: ''},
  {name: 'API', value: LaneTypeEnum.API},
  {name: 'Sentry Cloud', value: LaneTypeEnum.SENTRY_CLOUD},
  {name: 'Smartcapture', value: LaneTypeEnum.SMARTCAPTURE}
];

export const CAMERAS_SETUP = [
  {label: 'Traseira', value: 'back'},
  {label: 'Dianteira', value: 'forward'},
  {label: 'Dianteira + Traseira', value: 'forwardback', disableOnMobile: true},
  {label: 'FTP (descontinuado)', value: 'ftp', disableOnMobile: true}
];
export const localDateObj = {
  day: "2-digit",
  month: "2-digit",
  year: "numeric",
  hour: "2-digit",
  minute: "2-digit",
  second: "2-digit"
}